import cart from '@/constants/cart';
import Utils from '@/utils/utils';
let toolsSource = 'item_source';
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  let __now = new Date().getTime();

  if (urlParams.has('source')) {
    window.localStorage.__channel__time = __now;
    localStorage.setItem(toolsSource, 'ppc');
  } else {
    if (!localStorage.getItem(toolsSource)) {
      localStorage.setItem(toolsSource, 'seo');
    }
  }

  // 2.時間
  let __channel__time = window.localStorage.__channel__time;
  if (!__channel__time) {
    console.warn('__channel__time is invalid', __channel__time);
    return;
  }

  // let __now=Date.now()
  let ItIs30daysPass =
    (__now - __channel__time) * (1 / 1e3) * (1 / 60) * (1 / 60) * (1 / 24) > 30;
  console.log('ItIs30daysPass', ItIs30daysPass, __channel__time);
  if (ItIs30daysPass) {
    localStorage.setItem(toolsSource, 'seo');
  }
})();

let cartUrl = (URLcart) => {
  console.log('cartUrl', URLcart);

  let lang = Utils.getLanguage() || 'en';
  let func = '37';

  // 1,2,5,8
  let reason = '9';
  let __findHost = cart.host.find(
    (v) => v.lang.trim().toLowerCase() === lang.trim().toLowerCase()
  );
  let host = __findHost?.host || '1';
  let platform = cart.platform[Utils.systemCheck()];
  // 套餐 年月周
  let ab = '0Z';
  let channel = window.localStorage.getItem(toolsSource);
  let discount = '0';
  let track = {
    type: '4',
    sid: '116',
    func: func,
    reason: reason,
    host: host,
    platform: platform,
    ab: ab,
    channel: channel,
    discount: discount,
  };
  return track;
};

export default cartUrl;
